import { CustomCollection, Stream } from '@/__generated__/schema-types';

export type SourceCustomTargetsMap = Record<string, string[]>;

export const sourceConfigsToTargetsMap = (
  sourceConfigs?: CustomCollection['sourceConfigs'] | null,
): SourceCustomTargetsMap =>
  Object.fromEntries(
    (sourceConfigs ?? [])
      .filter(
        (config) => !config.usesAllTargets && config.customTargets.length > 0,
      )
      .map((config) => [config.stream.id, config.customTargets]),
  );

export const isSubscribedCustomStream = (stream: Stream, meId: string) =>
  !!stream.customTargetsData && stream.author?.id !== meId;
